module.exports = __webpack_public_path__ + "img/6.16ca1717.jpg";